import { UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { GetChatToUpdate } from '../../../modules/chat/types/chat.types';
import {
  getAllChatsNotificationsKey,
  getChatToUpdateKey,
  getFindGroupedChatsKey,
} from './chats.keys';
import { findGroupedChats, getAllChatsNotifications, getChatToUpdate } from './chats.repository';
import {
  FindGroupedChatsOutput,
  FindGroupedChatsParams,
  GetAllChatsNotificationsOutput,
} from './chats.types';

export const useGetAllChatsNotifications = (options?: UseDataQueryOptions) =>
  useDataQuery<GetAllChatsNotificationsOutput | null>(
    {
      queryKey: getAllChatsNotificationsKey(),
      queryFn: async () => {
        const data = await getAllChatsNotifications();
        if (!data.ok || !data.data) {
          return null;
        }
        return data.data;
      },
    },
    options,
  );

export const useFindGroupedChats = (
  params: FindGroupedChatsParams,
  options?: UseDataQueryOptions,
) =>
  useDataQuery<FindGroupedChatsOutput | null>(
    {
      queryKey: getFindGroupedChatsKey(params),
      queryFn: async () => {
        const response = await findGroupedChats(params);
        if (!response.ok || !response.data) {
          return null;
        }
        return response.data;
      },
    },
    options,
  );

export const useGetChatToUpdate = (chatId: string, options?: UseDataQueryOptions) =>
  useDataQuery<GetChatToUpdate | null>(
    {
      queryKey: getChatToUpdateKey(chatId),
      queryFn: async () => {
        const response = await getChatToUpdate(chatId);
        if (!response.ok || !response.data) {
          return null;
        }
        return response.data;
      },
    },
    options,
  );
